import { AuviousCommon, IOAuth2Token } from "@auvious/common";
import { AppConfigService as Config } from "./app.config.service";
import { ITicketRequest, EventClient, KEY_REFRESH_TOKEN } from "../models";
import ky from "ky";
import { StorageService } from "./storage.service";
import { Log } from "./log.service";
import { Subscription } from "rxjs";

class AuthServiceCtrl {
  private commonClient: AuviousCommon;
  private eventClient: EventClient;
  private authToken: IOAuth2Token;
  private subscription: Subscription;

  /**
   *
   * @param ticket
   * @param commonClient an initialised common client instance
   * @param eventHandler subscribe to common events
   * @returns the
   */
  async authenticate(
    ticket: string,
    commonClient: AuviousCommon,
    eventHandler: (e) => void
  ): Promise<ITicketRequest> {
    try {
      this.commonClient = commonClient;

      const ticketResponse: ITicketRequest = (await ky
        .get(`${Config.auviousBaseUrl}/security/ticket/${ticket}`)
        .json()) as any;

      this.eventClient = new EventClient(this.commonClient);
      this.subscription = this.eventClient
        .connect()
        .subscribe((e) => eventHandler(e));

      let refreshToken = this.getRefreshToken(ticket);

      const params = new URLSearchParams();
      params.set("client_id", "customer");

      if (refreshToken) {
        params.set("grant_type", "refresh_token");
        params.set("refresh_token", refreshToken);
      } else {
        params.set("grant_type", "password");
        params.set("username", ticket);
      }

      this.authToken = await this.commonClient.loginTemplate(
        () =>
          ky
            .post(`${Config.auviousBaseUrl}/security/oauth/token`, {
              body: params,
              headers: {
                "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
              },
            })
            .json(),
        async (refreshToken) => {
          const refreshTokenParams = new URLSearchParams();
          refreshTokenParams.set("client_id", params.get("client_id"));
          refreshTokenParams.set("grant_type", "refresh_token");
          refreshTokenParams.set("refresh_token", refreshToken);

          const token = await (
            await ky.post(`${Config.auviousBaseUrl}/security/oauth/token`, {
              body: refreshTokenParams,
              headers: {
                "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
              },
            })
          ).json();

          StorageService.setItem(
            `${KEY_REFRESH_TOKEN}.${ticket}`,
            token.refresh_token,
            "session"
          );

          return token;
        }
      );

      Log.info("cobrowse: token: ", this.authToken);

      StorageService.setItem(
        `${KEY_REFRESH_TOKEN}.${ticket}`,
        this.authToken.refreshToken,
        "session"
      );

      Log.info("cobrowse: ticket response: ", ticketResponse);
      return ticketResponse;
    } catch (ex) {
      throw ex;
    }
  }

  private getRefreshToken(ticket: string) {
    return StorageService.getItem(`${KEY_REFRESH_TOKEN}.${ticket}`, "session");
  }

  public get accessToken(): string {
    return this.authToken?.accessToken;
  }

  public destroy() {
    // this.rtcClient = undefined;
    this.commonClient = undefined;
    // unsubsribe from events
    this.subscription.unsubscribe();
    if (this.eventClient) {
      this.eventClient.disconnect();
      this.eventClient = undefined;
    }
  }
}

export const AuthService = new AuthServiceCtrl();
